import { useFFContext } from '@/components/OpenFeature/hooks/useFFContext';
import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { TransactionItems } from '@/features/transaction_items/TransactionItems';
import { OpenFeatureProvider } from '@moneyforward/user-flex-feature-hooks';
import { FC, memo } from 'react';

const TransactionItemsPage: FC = memo(() => {
  const context = useFFContext();
  return (
    <Wrapper isProto={false}>
      <OpenFeatureProvider
        pollInterval={-1}
        context={context}
        domain='flexible-validation-for-invoice-transaction'
      >
        <TransactionItems />
      </OpenFeatureProvider>
    </Wrapper>
  );
});

TransactionItemsPage.displayName = 'TransactionItemsPage';
export default TransactionItemsPage;
